import { bulk } from './update';
import addError from '../../../utils/error.jsx';

export function request(tag, value) {
    return {
        type: 'TAGS_EDIT_REQUEST',
        tag,
        value
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'TAGS_EDIT_ERROR',
        errors
    };
}

export function finish(tags) {
    return (dispatch) => {
        dispatch(bulk(tags));

        dispatch({
            type: 'TAGS_EDIT_FINISH',
            tags
        });
    };
}

export function clear() {
    return {
        type: 'TAGS_EDIT_CLEAR'
    };
}
